import { computed } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import AddNarrative from "./AddNarrative"
import NarrativeList from "./NarrativeList"

const IncidentNarrative: ReactiveComponent = () => {
	const handler = useIncidentHandler()
	const narrative = computed(() => {
		const entries = handler.incident.incidentNarrative ? [...handler.incident.incidentNarrative] : []
		return entries.sort((n1, n2) => n1.creationMetadata.timeStamp.compareTo(n2.creationMetadata.timeStamp))
	})

	return () => (
		<>
			{handler.readOnly && narrative.value.length === 0 && <>No narrative has been added.</>}
			<NarrativeList entries={narrative.value} />
			{!handler.readOnly && <AddNarrative />}
		</>
	)
}

export default defineComponent(IncidentNarrative)
